module.exports = __webpack_public_path__ + "img/question.0336bb4d.svg";